<script>
import {mapState} from "pinia";
import {authStore} from "@/store/authStore";
import NotApprovedUserMessage from "@/components/HeaderMessage/NotApprovedUserMessage.vue";
import CookiePolicyMessage from "@/components/HeaderMessage/CookiePolicyMessage.vue";
import {maintenanceStore} from "@/store/maintenanceStore";
import ManagerSystemMaintenanceMessage from "@/components/HeaderMessage/ManagerSystemMaintenanceMessage.vue";
import {userStore} from "@/store/userStore";

export default {
  name: "BaseHeaderMessage",
  components: {
    NotApprovedUserMessage,
    CookiePolicyMessage,
    ManagerSystemMaintenanceMessage
  },
  computed: {
    ...mapState(userStore, [
      'userHasApprovedEmail'
    ]),
    ...mapState(authStore, [
      'userInfo',
      'showCookiePolicyMessage'
    ]),
    ...mapState(maintenanceStore, [
      'isResolveContentReviewBlocked'
    ]),
    showNotApprovedUserMsg() {
      return !this.userHasApprovedEmail && this.userInfo;
    }
  },
  methods: {
    onClose() {
      this.$emit('on-close');
    }
  }
}
</script>

<template>
  <div class="header-message" id="baseHeaderMessage">
    <not-approved-user-message v-if="showNotApprovedUserMsg"/>
    <cookie-policy-message v-else-if="showCookiePolicyMessage"
                           @on-accept="onClose()"
    />
    <manager-system-maintenance-message v-if="isResolveContentReviewBlocked"
                                        @on-hide="onClose()"
    />
  </div>
</template>

<style lang="scss" scoped>
.header-message {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1001;
}
</style>